import React, { useMemo } from "react";
import _ from "underscore";
import {
    CourseItem,
    tableFill,
    tableTranspose
} from "../../../../service/service";
import DayCell from "./components/DayCell";
import style from "./index.module.scss";
import moment from "moment";
import useCurrentDate from "../../../../utils/useCurrentDate";
import classNames from "classnames";

interface DayItems {
    day: string;
    courses: CourseItem[];
}

interface WeekCalendarProps {
    startDate: string;
    endDate: string;
    data: DayItems[];
    showMore?: boolean;
    type?: "home" | "my";
}
// type 原因：我的里面的日历是弹窗，需要改变大小
export default function WeekCalendar({
    data,
    startDate,
    endDate,
    showMore = true,
    type = "home"
}: WeekCalendarProps) {
    const { time } = useCurrentDate();

    // 简化为二维数组
    const table1 = _.pluck(data, "courses");

    const minColumnCount = useMemo(() => {
        return _.reduce(
            table1,
            (memo, item) => {
                return Math.max(_.compact(item).length, memo);
            },
            4
        );
    }, [table1]);

    // 用指定尺寸填充表格
    const table2 = tableFill(table1, {
        rows: 7,
        columns: minColumnCount,
        fill: undefined
    });

    // 行列互换
    const table3 = tableTranspose(table2);

    // 一周的每天
    const weekDays = useMemo(() => {
        const days = new Array(7)
            .fill(1)
            .map((ful, index) => moment(startDate).add(index, "d"));
        return days.map(day => ({
            week: day.format("dddd"),
            date: day.format("M月D日"),
            isToday: day.isSame(time, "day")
        }));
    }, [startDate, endDate]);

    return (
        <div className={style.root}>
            <table>
                <thead>
                    <tr>
                        {weekDays.map(day => (
                            <th
                                key={day.date}
                                className={classNames({
                                    [style.todayTh]: day.isToday
                                })}>
                                {day.week}
                                <span>{day.isToday ? "今天" : day.date}</span>
                            </th>
                        ))}
                    </tr>
                </thead>

                <tbody>
                    {table3.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                            {row.map((column, columnIndex) => (
                                <td
                                    key={columnIndex}
                                    width={`${100 / 7}%`}
                                    className={classNames({
                                        [style.todayTd]:
                                            weekDays[columnIndex].isToday,
                                        [style.empty]: !column
                                    })}>
                                    <DayCell
                                        type={type}
                                        showMore={showMore}
                                        course={column}
                                    />
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
